// Stimulus
import { Application } from '@hotwired/stimulus';
import { registerControllers } from 'stimulus-vite-helpers';

// Turbo
import * as Turbo from '@hotwired/turbo';

// GSAP and ScrollTrigger
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Favicons
import '../assets/img/favicon/apple-touch-icon.png';
import '../assets/img/favicon/favicon-96x96.png';
import '../assets/img/favicon/favicon.ico';
import '../assets/img/favicon/favicon.svg';

// Assets
import '../assets/img/logo-email.png';
import '../assets/img/logo-menzis.svg';

// Icons
import '../assets/img/icon-2-chevrons.svg';
import '../assets/img/icon-3-bars.svg';
import '../assets/img/icon-arrow.svg';
import '../assets/img/icon-care.svg';
import '../assets/img/icon-chevron.svg';
import '../assets/img/icon-community.svg';
import '../assets/img/icon-facebook.svg';
import '../assets/img/icon-healthcare-worker.svg';
import '../assets/img/icon-instagram.svg';
import '../assets/img/icon-linkedin.svg';
import '../assets/img/icon-minus.svg';
import '../assets/img/icon-play.svg';
import '../assets/img/icon-plus.svg';
import '../assets/img/icon-reset.svg';
import '../assets/img/icon-resident.svg';
import '../assets/img/icon-share.svg';
import '../assets/img/icon-spinner.svg';
import '../assets/img/icon-support.svg';
import '../assets/img/icon-volunteer.svg';
import '../assets/img/icon-x-mark.svg';

// Lottie
import '../assets/lottie/logo.lottie';

// Start Stimulus
const application = Application.start();
const controllers = import.meta.glob('./**/*_controller.js', { eager: true });
registerControllers(application, controllers);

// Start Turbo
Turbo.start();

// Register GSAP ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR'); // eslint-disable-line no-console
  });
}
